// extracted by mini-css-extract-plugin
module.exports = {"subheading":"ViewCoursesByStatus_subheading_1SMhq"};